export default {"badge":"_0IRis","ai":"HybD6","statsIcon":"Y2Juz"};